import React from "react";
import Box from '@mui/material/Box';
import {WalletContext} from "./../../contexts/Wallet";
import {api} from "./../../services/ResourceService";
import Carousel from 'react-material-ui-carousel'
import { Paper, LinearProgress, Button, Hidden } from '@mui/material'
import QuestionMark from "@mui/icons-material/QuestionMarkOutlined"
import LoadingButton from "../LoadingButton/LoadingButton";

export default function Product({product, property={}}){
  const wallet = React.useContext(WalletContext);
  const [onSubmit, setOnSubmit] = React.useState(false);


	const onClick = async()=>{
    let res = null;
    if(!wallet.chainNetwork.account.address) return api.handleError(new Error("Wallet is missing"));
    if(onSubmit) return;
    setOnSubmit(true);
    try {
       res = await api.post(`/products/${product.id}/checkout`, {clientUrl: window.location.origin, walletAddress:wallet.chainNetwork.account.address});
    }
    catch(err) {

    }
	  setOnSubmit(false);
    window.location.href = res.url;
  }


const Item = (props) => 
{ 
  const {item} = props;
    return (
        <Paper sx={{backgroundColor: "#d3d3d3", position: "relative", height: "100%"}}>
           <Box sx={{padding: "50px 0", width: "100%", height: "100%"}}>
              <div style={{width: "75%", margin: "0 auto"}}> 
                <picture>
                  <source width="100%" className="custom-carousel-img" srcSet={item} type="image/webp">
                  </source>
                  <img className="custom-carousel-img" src={product.images[0] ||""} alt="cover" width="100%"/>
                </picture>
              </div>
           </Box>
           <Box sx={{position: "absolute", bottom: "10px", textAlign: "center", width: "100%"}}>
              <h2 className="cover-book-text" style={{margin: "0"}}>BookNFT signed by Sze and delivered to you!</h2>
              <p className="cover-book-text" style={{margin: "0"}}>100 cover variation for BookNFT</p>
          </Box>
        </Paper>
    )
}

const Loader = () => {
  return (
    <Box sx={{position: "absolute", left: "50%", top: "50%", textAlign: "center"}}>
     <LinearProgress/>
    </Box>
  )
}

const ProductInfo = () => {
  return <Box sx={{width: ["auto", "auto", "50%"], padding: ["30px", "30px", "20px 100px 20px 100px"], order: ["2", "2" ,"1"]}}>
          <h1 className="Product-info-title">{"Craft Your World"} <span className="Product-info-subtitle special">NFT</span></h1>
        
          <span className="Product-info-subtitle">by Sze Wong</span>

          <p className="Product-info-description">You don't have to change the world. You just have to change your world.
          <br/>
This book provides you with one of the key ways that you can craft your world: <br/> entrepreneurship.
<br/>Through entrepreneurship, you can shape your professional life, your financial future,<br/> and who you will interact with on a regular basis. Rather than feeling stuck, you can<br/> take charge of your life and craft a world that you can find success in.
<br/>Through entrepreneurship, you can create an opportunity to do what you love.</p>
        <Box sx={{display: "flex", flexDirection: ["column", "column", "row"], width: ["100%", "100%", "450px"], alignItems: "center", marginTop: ["50px", "50px", "20px"]}}>
          <Hidden smDown>
            {
            !wallet.chainNetwork.account.address?
            <Button className="buy-now" sx={{padding: ["5px, 15px", "5px 45px"], background: "#d9d9d9", color: "black"}} variant="outlined" onClick={()=>wallet.chainNetwork.onWalletChange()}>Connect Your Wallet</Button>
            :
            onSubmit ? 
              <LoadingButton color="yellow"></LoadingButton>:
              <Button  sx={{background: "yellow", color: "black", padding: ["5px 15px", "5px 55px"]}} variant="outlined" onClick={onClick}>BUY NOW</Button>
            }
          <span className="Product-info-price">$9.99</span>
          </Hidden>

          <Hidden smUp>
          <span className="Product-info-price">$9.99</span>
          {
          !wallet.chainNetwork.account.address?
          <Button className="buy-now" sx={{padding: ["5px, 15px", "5px 45px"], background: "#d9d9d9", color: "black"}} variant="outlined" onClick={()=>wallet.chainNetwork.onWalletChange()}>Connect Your Wallet</Button>
          :
           onSubmit ? 
            <LoadingButton color="yellow"></LoadingButton>:
            <Button  sx={{background: "yellow", color: "black", padding: ["5px 15px", "5px 55px"]}} variant="outlined" onClick={onClick}>BUY NOW</Button>
          }
          </Hidden>
        </Box>
    </Box>
}

const ProductGallery = () => {
  return <Box sx={{width: ["100%", "100%", "50%"], order: ["1", "1" ,"2"]}}>
    <Carousel height={window.screen.width > 998 ? "650px": "350px"} className="custom-carousel" indicators={false} navButtonsAlwaysVisible={true}>
      {
       (product.images ||[]).map((img, i) => <Item item={img} key={i}></Item>)
      }
    </Carousel>
</Box>
}

	return (
    <>
    <Box sx={{width: "100%", height: "100%"}}>
      {
        !product ? <Loader/>: 
        <>
        <Box sx={{width: "100%", display: "flex", flexDirection: ["column", "column", "row"], alignItems: ["start", "start", "center"]}}>
          <ProductInfo/>
          <ProductGallery/>
        </Box>

        <Box sx={{display: "flex",flexDirection: ["column", "column", "row"], width: "100%"}}>
          <Box sx={{width: ["auto", "50%", "50%"], marginTop: ["0px", "0px","-50px"], padding: ["30px", "30px", "0px 100px"]}}>
              <Box>
                <a style={{display: "flex", alignItems: "center", textDecoration: "none", color: "black"}} href="https://help.keplr.app/articles/installation-guide-for-keplr-extension-for-beginners" className="Product-info-subtitle"><QuestionMark style={{marginRight: "10px"}}/> How to install Keplr wallet</a>
              </Box> 
          </Box>
          <Box sx={{width: ["auto", "50%", "50%"], padding: "50px 30px", textAlign: ["center", "center", "start"]}}>
            <Box>
              <p className="Product-info-subtitle">Check first few pages</p>
              <Box sx={{display: "flex", flexDirection: ["column", "column", "row"], alignItems: ["space-between", "space-between", "start"], justifyContent: ["start", "start", "space-between"]}}>
                {
                  (product.trials ||[]).map((trial, index) => (
                    <Box className={`cover-book-wrap-${index + 1}`} key={index} sx={{width: ["100%", "100%", "33%"], textAlign: "center"}}><img className="cover-book" style={{marginBottom: "20px"}} width="100%" src={trial} alt="book pages"/></Box>
                  ))
                }
              </Box>
            </Box>
          </Box>
        </Box>
        </>
      }
    </Box>
    </>
	);
}